var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wrap" } },
    [
      _c("MainHeader", { attrs: { hidden: true } }),
      _c("header", { staticClass: "replboxHead" }, [
        _c(
          "div",
          {
            staticClass: "btn_back",
            on: {
              click: function($event) {
                return _vm.$go(-1)
              }
            }
          },
          [_vm._m(0)]
        ),
        _c(
          "div",
          {
            staticClass: "btn_home",
            on: {
              click: function($event) {
                return _vm.$router.push("/main")
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$router.push("/main")
              }
            }
          },
          [_vm._m(1)]
        ),
        _c("h1", [
          _vm._v("상품 선택"),
          _vm.batch_dlv_yn === "Y"
            ? _c("span", { staticClass: "tag" }, [_vm._v("일괄 배송")])
            : _vm._e()
        ]),
        _c("div", { staticClass: "menu_side" }, [
          _c(
            "a",
            {
              staticClass: "search",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.$refs.searchMain.openSearch()
                }
              }
            },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("상품 찾기")])]
          ),
          _vm._m(2)
        ])
      ]),
      _c("div", { staticClass: "header_sub" }, [
        _c("div", { staticClass: "select_group_header" }, [
          _c("div", { staticClass: "selectbox_group" }, [
            _c(
              "p",
              {
                staticClass: "select_label",
                attrs: {
                  "aria-label": "내 그룹 목록 보기",
                  role: "button",
                  "aria-expanded": "false",
                  "aria-controls": "groupContent",
                  tabindex: "0"
                },
                on: {
                  click: function($event) {
                    return _vm.changeMenu()
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeMenu()
                  }
                }
              },
              [
                _vm._v(" " + _vm._s(this.selectedGroup.group_nm) + " "),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(this.selectedGroup.cart_cnt))
                ])
              ]
            ),
            _c(
              "ul",
              {
                staticClass: "selectbox_group_ul",
                attrs: { id: "groupContent", "aria-hidden": "true" }
              },
              [
                _vm.eventDtl.is_update_event_yn === "Y"
                  ? _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            return _vm.groupModal(true, "new")
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "new_item",
                            attrs: { href: "javascript:void(0)" }
                          },
                          [_vm._v("그룹 추가하기")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.groupFiltering, function(group, i) {
                  return _c(
                    "li",
                    {
                      key: group.group_no,
                      class: {
                        on: _vm.selectedGroup.group_no === group.group_no
                      },
                      staticStyle: { "margin-right": "15px" },
                      attrs: { id: "group_" + i }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.selectGroup(group, i)
                            }
                          }
                        },
                        [
                          _vm._v(_vm._s(group.group_nm) + " "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(group.cart_cnt))
                          ])
                        ]
                      ),
                      _vm.eventDtl.is_update_event_yn === "Y"
                        ? _c("i", {
                            staticClass: "xi-pen",
                            attrs: {
                              role: "button",
                              "aria-label": "그룹명 수정",
                              tabindex: "0"
                            },
                            on: {
                              click: function($event) {
                                return _vm.groupModalUpdate(
                                  true,
                                  "update",
                                  group,
                                  i
                                )
                              },
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.groupModalUpdate(
                                  true,
                                  "update",
                                  group,
                                  i
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _c("li", { staticClass: "toggle_wrap" }, [
            _c("span", { staticClass: "txt" }, [
              _c("i", {
                staticClass: "xi-help",
                attrs: {
                  role: "button",
                  "aria-label": "일괄배송 안내",
                  tabindex: "0"
                },
                on: {
                  click: function($event) {
                    return _vm.help()
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.help()
                  }
                }
              }),
              _vm._v("일괄 배송")
            ]),
            _c("label", { staticClass: "toggle_switch" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.batch_dlv_yn,
                    expression: "batch_dlv_yn"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  id: "chkBatch_dlv_yn",
                  "true-value": "Y",
                  "false-value": "N",
                  disabled: _vm.eventDtl.is_update_event_yn === "N",
                  "aria-label": "일괄 배송"
                },
                domProps: {
                  checked: Array.isArray(_vm.batch_dlv_yn)
                    ? _vm._i(_vm.batch_dlv_yn, null) > -1
                    : _vm._q(_vm.batch_dlv_yn, "Y")
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.batch_dlv_yn,
                        $$el = $event.target,
                        $$c = $$el.checked ? "Y" : "N"
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.batch_dlv_yn = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.batch_dlv_yn = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.batch_dlv_yn = $$c
                      }
                    },
                    function($event) {
                      return _vm.changeBatchDlvYn()
                    }
                  ]
                }
              }),
              _c("p", { staticClass: "slider" })
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticStyle: {
              position: "relative",
              display: "flex",
              "border-bottom": "1px solid #dfdfdf",
              "z-index": "4",
              "background-color": "white"
            }
          },
          [
            _c(
              "ul",
              { ref: "product_scroll", staticClass: "list_header_product" },
              _vm._l(_vm.goodsCategory, function(category) {
                return _c(
                  "li",
                  {
                    key: category.disp_ctg_no,
                    ref: "category_" + category.disp_ctg_no,
                    refInFor: true,
                    class: { on: _vm.event_divi_cd === category.disp_ctg_no },
                    staticStyle: { "margin-right": "15px" },
                    attrs: { id: "category_" + category.disp_ctg_no },
                    on: {
                      click: function($event) {
                        return _vm.changeProduct(category, 0)
                      }
                    }
                  },
                  [
                    _c("a", { attrs: { href: "javascript:void(0)" } }, [
                      _vm._v(_vm._s(category.disp_ctg_nm))
                    ])
                  ]
                )
              }),
              0
            ),
            _c("button", { staticClass: "btn_toggle" }, [_vm._v("메뉴")])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "navi_bg",
            staticStyle: { display: "none" },
            attrs: { "aria-hidden": "true" }
          },
          [
            _c("div", { staticClass: "navigation-list" }, [
              _c("h2", [_vm._v("REPLBOX")]),
              _c("dl", { staticClass: "tag-box" }, [
                _vm._m(3),
                _c(
                  "dd",
                  _vm._l(_vm.planList, function(category) {
                    return _c(
                      "a",
                      {
                        key: category.disp_ctg_no,
                        class: {
                          menu_tag: _vm.event_divi_cd === category.disp_ctg_no
                        },
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.changeProduct(category, 0)
                          }
                        }
                      },
                      [_vm._v(_vm._s(category.disp_ctg_nm))]
                    )
                  }),
                  0
                )
              ]),
              _c("h2", [_vm._v("시즌 기획전")]),
              _c("dl", { staticClass: "tag-box" }, [
                _vm._m(4),
                _c(
                  "dd",
                  _vm._l(_vm.bannerList, function(category) {
                    return _c(
                      "a",
                      {
                        key: category.disp_ctg_no,
                        class: {
                          menu_tag: _vm.event_divi_cd === category.disp_ctg_no
                        },
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.changeProduct(category, 0)
                          }
                        }
                      },
                      [_vm._v(_vm._s(category.disp_ctg_nm))]
                    )
                  }),
                  0
                )
              ]),
              _c("h2", [_vm._v("상황별 추천")]),
              _c("dl", { staticClass: "tag-box" }, [
                _vm._m(5),
                _c(
                  "dd",
                  _vm._l(_vm.categoryList, function(category) {
                    return _c(
                      "a",
                      {
                        key: category.disp_ctg_no,
                        class: {
                          menu_tag: _vm.event_divi_cd === category.disp_ctg_no
                        },
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            return _vm.changeProduct(category, 0)
                          }
                        }
                      },
                      [_vm._v(_vm._s(category.disp_ctg_nm))]
                    )
                  }),
                  0
                )
              ]),
              _vm._m(6)
            ]),
            _c("div", { staticClass: "dimmed" })
          ]
        ),
        _c(
          "ul",
          { staticClass: "filter_price product" },
          _vm._l(_vm.priceFilterList, function(price) {
            return _c(
              "li",
              {
                key: price.disp_ctg_nm,
                class: {
                  on:
                    _vm.selectedPriceFilter.min === price.min &&
                    _vm.selectedPriceFilter.max === price.max
                },
                on: {
                  click: function($event) {
                    _vm.selectedPriceFilter = price
                  }
                }
              },
              [
                _c("a", { attrs: { href: "javascript:void(0)" } }, [
                  _vm._v(_vm._s(price.disp_ctg_nm))
                ])
              ]
            )
          }),
          0
        )
      ]),
      _c(
        "section",
        { staticClass: "select_product" },
        [
          _vm.event_divi_cd === _vm.search && (!_vm.loading || !_vm.search_new)
            ? _c(
                "div",
                {
                  staticClass: "product_srch_result",
                  staticStyle: { padding: "20px 0 0" }
                },
                [
                  _c("h6", [
                    _c("span", { staticClass: "caption" }, [
                      _vm._v("'" + _vm._s(_vm.params.searchTerm) + "'")
                    ]),
                    _vm._v(" 검색결과")
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "caption" }, [
                      _vm._v(
                        _vm._s(
                          _vm.searchGoodsLength + _vm.searchGishowGoodsLength
                        ) + "개"
                      )
                    ]),
                    _vm._v(" 상품이 검색되었습니다.")
                  ]),
                  _c(
                    "ul",
                    {
                      staticClass: "list_header_product",
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "15px",
                        border: "none"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            on:
                              _vm.params.searchType ===
                              _vm.$store.getters[
                                "systemStore/PV_GOOD_TYPE_CD_NORMAL"
                              ]
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeSearchType(
                                _vm.$store.getters[
                                  "systemStore/PV_GOOD_TYPE_CD_NORMAL"
                                ]
                              )
                            }
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(
                              "상품 (" + _vm._s(_vm.searchGoodsLength) + ")"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "li",
                        {
                          class: {
                            on:
                              _vm.params.searchType ===
                              _vm.$store.getters[
                                "systemStore/PV_GOOD_TYPE_CD_GIFTISHOW"
                              ]
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeSearchType(
                                _vm.$store.getters[
                                  "systemStore/PV_GOOD_TYPE_CD_GIFTISHOW"
                                ]
                              )
                            }
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(
                              "기프티쇼 (" +
                                _vm._s(_vm.searchGishowGoodsLength) +
                                ")"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "product_list_wrap" },
            [
              _vm.goodsFiltering.length > 0
                ? _c(
                    "ul",
                    { staticClass: "product_list" },
                    _vm._l(_vm.goodsFiltering, function(goods) {
                      return _c(
                        "li",
                        {
                          key: goods.good_no,
                          on: {
                            click: function($event) {
                              _vm.selectedGoods = goods
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: {
                                product_list_box: true,
                                active: goods.sel_yn === "Y"
                              },
                              attrs: { id: goods.good_no }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.goodDtl.searchGood(
                                        _vm.$route.params.event_no,
                                        goods.good_no,
                                        goods.ord_qty,
                                        _vm.batch_dlv_yn
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "thumb" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          _vm.$store.getters[
                                            "systemStore/getImgPath"
                                          ] + goods.img_path,
                                        alt: goods.good_nm
                                      }
                                    }),
                                    goods.new_good_yn === "Y"
                                      ? _c(
                                          "div",
                                          { staticClass: "thumb_tag" },
                                          [_vm._v("NEW")]
                                        )
                                      : _vm._e(),
                                    goods.good_type_cd ===
                                    _vm.$store.getters[
                                      "systemStore/PV_GOOD_TYPE_CD_GIFTISHOW"
                                    ]
                                      ? _c("div", {
                                          staticClass: "thumb_tag_gishow"
                                        })
                                      : _vm._e()
                                  ]),
                                  _vm.batch_dlv_yn == "Y"
                                    ? _c("div", { staticClass: "info" }, [
                                        _c("p", [
                                          _vm._v(_vm._s(goods.good_nm))
                                        ]),
                                        _c("strong", [
                                          _c("em", [
                                            _vm._v(
                                              _vm._s(
                                                goods.sale_price.toLocaleString()
                                              )
                                            )
                                          ]),
                                          _vm._v("원")
                                        ])
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "info",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.addCart(goods)
                                            }
                                          }
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(_vm._s(goods.good_nm))
                                          ]),
                                          _c("strong", [
                                            _c("em", [
                                              _vm._v(
                                                _vm._s(
                                                  goods.sale_price.toLocaleString()
                                                )
                                              )
                                            ]),
                                            _vm._v("원")
                                          ])
                                        ]
                                      )
                                ]
                              ),
                              _vm.batch_dlv_yn === "N"
                                ? _c(
                                    "div",
                                    { staticClass: "input-form-checkbox" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: goods.sel_yn,
                                            expression: "goods.sel_yn"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "check" + goods.good_no,
                                          "true-value": "Y",
                                          "false-value": "N",
                                          disabled:
                                            _vm.eventDtl.is_update_event_yn ===
                                            "N",
                                          "aria-label":
                                            goods.good_nm + " 상품 선택"
                                        },
                                        domProps: {
                                          checked: Array.isArray(goods.sel_yn)
                                            ? _vm._i(goods.sel_yn, null) > -1
                                            : _vm._q(goods.sel_yn, "Y")
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.addCart(
                                              goods,
                                              null,
                                              "checkbox"
                                            )
                                          },
                                          change: function($event) {
                                            var $$a = goods.sel_yn,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? "Y" : "N"
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    goods,
                                                    "sel_yn",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    goods,
                                                    "sel_yn",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(goods, "sel_yn", $$c)
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "check" + goods.good_no
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "xi-check-min"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "product_count" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "minus",
                                            attrs: {
                                              disabled: goods.ord_qty === 0
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.addCart(
                                                  goods,
                                                  goods.ord_qty - 1
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("수량 빼기")]
                                            ),
                                            _c("i", {
                                              staticClass: "xi-minus-min"
                                            })
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: goods.ord_qty,
                                              expression: "goods.ord_qty"
                                            }
                                          ],
                                          staticClass: "num",
                                          staticStyle: { width: "28px" },
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            "aria-label": "수량"
                                          },
                                          domProps: { value: goods.ord_qty },
                                          on: {
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  goods,
                                                  "ord_qty",
                                                  $event.target.value
                                                )
                                              },
                                              function($event) {
                                                return _vm.checkQty(goods)
                                              }
                                            ],
                                            change: function($event) {
                                              return _vm.checkQty(goods)
                                            }
                                          }
                                        }),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "plus",
                                            on: {
                                              click: function($event) {
                                                return _vm.addCart(
                                                  goods,
                                                  goods.ord_qty + 1
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("수량 더하기")]
                                            ),
                                            _c("i", {
                                              staticClass: "xi-plus-min"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm.event_divi_cd === _vm.search &&
                  _vm.goodsFiltering.length === 0 &&
                  !_vm.loading
                ? _c("ul", [
                    _c("img", {
                      staticStyle: { margin: "100px 0px 150px" },
                      attrs: {
                        src: require("@/assets/images/empty_search.jpg")
                      }
                    })
                  ])
                : _vm._e(),
              _vm.limit > 0
                ? _c(
                    "infinite-loading",
                    {
                      attrs: {
                        spinner: "waveDots",
                        identifier: _vm.infiniteId,
                        distance: 3000
                      },
                      on: { infinite: _vm.infiniteHandler }
                    },
                    [
                      _c("div", {
                        staticStyle: {
                          color: "rgb(102, 102, 102)",
                          "font-size": "14px",
                          padding: "10px 0px"
                        },
                        attrs: { slot: "no-more" },
                        slot: "no-more"
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("Footer")
        ],
        1
      ),
      _c("button", { staticClass: "top_btn" }, [_vm._v("top")]),
      _c(
        "button",
        {
          staticClass: "content_btn",
          on: {
            click: function($event) {
              return _vm.finishSelectGoods()
            }
          }
        },
        [
          _vm._v(
            _vm._s(
              this.eventDtl.is_update_event_yn === "N" ? "다 음" : "선 택 완 료"
            )
          )
        ]
      ),
      _c("GoodDtl", {
        ref: "goodDtl",
        attrs: { price_hidden: false },
        on: { addcart: _vm.emitAddCard }
      }),
      _c(
        "div",
        {
          class: { "popup group": true, active: _vm.groupDivi1 },
          attrs: { "aria-hidden": "true", tabindex: "-1" }
        },
        [
          _c("div", { staticClass: "popup_container" }, [
            _c("header", { staticClass: "popup_header" }, [
              _vm._v(
                "그룹 " + _vm._s(_vm.groupDivi2 === "new" ? "추가" : "수정")
              )
            ]),
            _c("div", { staticClass: "popup_content" }, [
              _c("div", { staticClass: "input_container" }, [
                _c("p", [_vm._v("그룹명")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.popupGroup.group_nm,
                      expression: "popupGroup.group_nm"
                    }
                  ],
                  attrs: {
                    type: "text",
                    maxlength: "30",
                    readonly: _vm.popupGroup.scene_group === "Y",
                    "aria-label": "그룹명 입력"
                  },
                  domProps: { value: _vm.popupGroup.group_nm },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.popupGroup, "group_nm", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "popup_button" }, [
              _c(
                "button",
                {
                  staticClass: "btn_large",
                  on: {
                    click: function($event) {
                      return _vm.crudGroup(_vm.groupDivi2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.groupDivi2 === "new" ? "추가" : "수정"))]
              ),
              _vm.groupDivi2 === "update"
                ? _c(
                    "button",
                    {
                      staticClass: "btn_large",
                      on: {
                        click: function($event) {
                          return _vm.crudGroup("delete")
                        }
                      }
                    },
                    [_vm._v("삭제")]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "btn_large",
                  on: {
                    click: function($event) {
                      return _vm.groupModal(false)
                    }
                  }
                },
                [_vm._v("닫기")]
              )
            ])
          ]),
          _c("div", { staticClass: "dimBg" })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "popup disp_goods_01",
          attrs: { tabindex: "-1", "aria-hidden": "true" }
        },
        [
          _c("div", { staticClass: "popup_container" }, [
            _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
            _c("div", { staticClass: "popup_content" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
            ]),
            _c("div", { staticClass: "popup_button" }, [
              _c(
                "button",
                {
                  staticClass: "btn_large",
                  on: {
                    click: function($event) {
                      return _vm.closeAlertModal("disp_goods_01")
                    }
                  }
                },
                [_vm._v("확인")]
              )
            ])
          ]),
          _c("div", { staticClass: "dimBg" })
        ]
      ),
      _c("Progress", { attrs: { active: _vm.progressActive } }),
      _c("SearchMain", {
        ref: "searchMain",
        attrs: { next: "search" },
        on: { searchGoods: _vm.emitSearchGoods }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "button", attrs: { href: "javascript:void(0)" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("이전으로 이동")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "button", attrs: { href: "javascript:void(0)" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("홈으로 이동")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn_menu",
        attrs: {
          onclick: "window.location.hash = location.hash +'#hamburger'",
          href: "javascript:void(0)"
        }
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("나의 메뉴 열기")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("p", [_vm._v("REPLBOX")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("p", [_vm._v("시즌 기획전")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("p", [_vm._v("상황별 추천")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "btn_toggle_close",
        attrs: { tabindex: "0", role: "button" }
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/images/menu_close.png"),
            alt: "닫기버튼"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }